import React, {useState} from 'react';
import {Formik} from 'formik';
import {useHistory} from 'react-router-dom';
import {
  CognitoUserAttribute,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import RegisterPageView from './RegisterPage-view';
import {pathnames as P} from 'common/constants/pathnames';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';
import {checkEmailIsValid} from 'common/utils/form/checkEmailIsValid';
import {errors as E, cognitoErrors as CE} from 'common/constants/errors';
import {genderOptions} from '../../../../common/constants/options';

import cognitoConfig from 'config/cognito';
const { PoolData } = cognitoConfig;

const RegisterPage = ({preRegister, register}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const history = useHistory();
  const initialValues = {
    password: '',
    confirmPassword: '',
    email: '',
    family_name: '',
    name: '',
    licence: '',
    gender: null,
  };

  const validate = values => {
    const {password, confirmPassword, licence, ...rest} = values;
    const errors = checkRequiredValues({password, confirmPassword, ...rest}, {});
    if (!checkEmailIsValid(values.email)) errors.email = E.INVALID_EMAIL;
    if (password !== confirmPassword) errors.confirmPassword = E.PASSWORDS_DONT_MATCH;

    return errors
  };

  const handleShowErrorMessage = () => {
    setErrorMessage(E.MUST_APPROVE_EMAIL);
    setShowErrorMessage(true);
  };

  const handleHideErrorMessage = () => {
    setShowErrorMessage(false)
  };

  const handleSubmit = values => {
    checkEmailIsAllowed(values.email)
      .then(() => registerToCognito(values))
      .then(() => transformRegisterData(values))
      .then(register)
      .then(() => handleShowErrorMessage())
      .catch(err => {
        console.error(err);
        setErrorMessage(CE[err.code] || err.message || JSON.stringify(err));
        setShowErrorMessage(true);
      })
  };
  const checkEmailIsAllowed = email => {
    return preRegister(email)
  };

  const registerToCognito = values => {
    const userPool = new CognitoUserPool(PoolData);
    return signUp(values, userPool);
  };

  const transformRegisterData = values => {
    const {email, name, family_name, licence, gender} = values;
    return {
      email,
      firstName: name,
      lastName: family_name,
      licenseNumber: licence,
      gender: gender.value
    }
  };

  const signUp = (values, userPool) => {
    const {confirmPassword, password, email, ...userInfo} = values;
    const attributeList = buildCognitoAttributes({email, ...userInfo});

    return new Promise((resolve, reject) => {
      userPool.signUp(
        email,
        password,
        attributeList,
        null,
        (err, result) => {
          if (err) {
            reject(err)
          } else {
            resolve();
          }
        });
    });
  };

  const goToLogin = () => {
    history.push(P.AUTH_LOGIN)
  };

  const buildCognitoAttributes = ({
                                    email,
                                    family_name,
                                    name,
                                    licence,
                                    gender
                                  }) => {
    const attributeEmail = new CognitoUserAttribute({
      Name: 'email',
      Value: email
    });
    const attributeFamilyName = new CognitoUserAttribute({
      Name: 'family_name',
      Value: family_name
    });
    const attributeName = new CognitoUserAttribute({
      Name: 'name',
      Value: name
    });
    const attributeLicence = new CognitoUserAttribute({
      Name: 'custom:licence',
      Value: licence
    });
    const attributeGender = new CognitoUserAttribute({
      Name: 'gender',
      Value: `${gender.value}`
    });

    return [
      attributeEmail,
      attributeName,
      attributeFamilyName,
      attributeLicence,
      attributeGender
    ];
  };

  const handleErrorMessageClose = () => {
    if (errorMessage === E.MUST_APPROVE_EMAIL) {
      goToLogin();
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <RegisterPageView
          {...formikProps}
          onLoginClick={goToLogin}
          messageText={errorMessage}
          showErrorMessage={showErrorMessage}
          hideGlobalErrorMessage={handleHideErrorMessage}
          genderOptions={genderOptions}
          onErrorMessageClose={handleErrorMessageClose}
        />
      )}
    </Formik>
  )
};

RegisterPage.propTypes = {};

export default RegisterPage;
